import { createAction } from '@reduxjs/toolkit'

/**
 * Команды фичи — plain actions (F05). UI вызывает actions binding-а, binding
 * dispatch-ит команду, listener исполняет её через порты. rid — в каждой
 * команде: listener не берёт базу из «выбранного ресурса» (D-064).
 */
export const productSaveRequested = createAction<{ resourceId: string; target: string }>('onec/products/saveRequested')

/** Отправить ТУ ЖЕ команду ещё раз тем же ключом: проверка неизвестного исхода. */
export const productOperationResendRequested = createAction<{ key: string }>('onec/products/resendRequested')

export const productMarkDeletedRequested = createAction<{
  resourceId: string
  refKey: string
  expectedConfigurationVersion: string
}>('onec/products/markDeletedRequested')

export type BarcodeAction = 'barcode-add' | 'barcode-delete' | 'barcode-main'

export const productBarcodeRequested = createAction<{
  resourceId: string
  refKey: string
  action: BarcodeAction
  barcode: string
  expectedConfigurationVersion: string
}>('onec/products/barcodeRequested')

/** «Обновить каталог из 1С» в базе окна: ревизию команда берёт свежим чтением, а не из поиска. */
export const catalogRefreshRequested = createAction<{ resourceId: string }>('onec/products/catalogRefreshRequested')

/** Перечитать товар (`refKey`) или списки базы (`null`). */
export const productReloadRequested = createAction<{ resourceId: string; refKey: string | null }>(
  'onec/products/reloadRequested',
)
